import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { StateProvider } from './shared/state';
import App from './App';

import { CookiesProvider } from 'react-cookie';
import 'shared/styles/theme.scss';
//import reportWebVitals from './reportWebVitals';

ReactDOM.render(
    <React.StrictMode>
        <StateProvider>
            <CookiesProvider>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </CookiesProvider>
        </StateProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
